/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */
import { useExtensions } from '@adobe/uix-host-react'
import { CommerceGridType, RegistrationProps, getRequestOptions } from './utils'

export const ProductMassAction = ({ url }: RegistrationProps) => {
  const { extensions } = useExtensions(() => ({
    updateOn: 'all',
    requires: {
      product: ['getMassActions']
    }
  }))

  extensions.map(async ({ apis, id }) => {
    const items = await apis.product.getMassActions()
    const completedItems = items.map((item: any) => ({
      ...item,
      extensionId: id,
      productSelectLimit: item.productSelectLimit ? item.productSelectLimit : -1
    }))
    updateMassActions(completedItems.flat())
  })

  function updateMassActions(registeredMassActions: FlatArray<any, any>) {
    const massActions = {
      gridType: CommerceGridType.CATALOG_PRODUCT,
      registrations: registeredMassActions
    }
    fetch(url, getRequestOptions('massActions', massActions)).then((response) =>
      response.json()
    )
  }
}
